import type { ReactNode } from 'react';

/**
 * DragScroll setting for horizontal scrolling with mouse drag.
 */
export const DragScroll = (): ReactNode => {
  return null;
};

DragScroll.displayName = 'DataTable.DragScroll';
